/* eslint-disable no-empty-pattern */
import { headers } from '@/_services/headers'
import { encrypt, decrypt } from '@/_services/encryption';
const state = {
   beneficiaries: [],
   allBanks: [],
};
const mutations = {
   // set beneficiaries
    SET_BENEFICIARIES(state, beneficiaries) {
         state.beneficiaries = beneficiaries;
    },
    // set all banks
    SET_ALL_BANKS(state, allBanks) {
        state.allBanks = allBanks;
    },
};
const actions = {
    // get beneficiaries
    async getBeneficiaries({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Beneficiary`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_BENEFICIARIES', userParseData);
            } 
            return response;
        }
    },
    // get all banks
    async getAllBanks({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Bank/getAll`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_ALL_BANKS', userParseData);
            } 
            return response;
        }
    },
    // create beneficiary
    async createBeneficiary({}, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Beneficiary/Create`, encryptedData, { headers });
            return response;
        }
    },
    // delete beneficiary
    async deleteBeneficiary({}, { body, id }) {
        const encryptedData = encrypt(body);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Beneficiary/delete/${id}`, encryptedData, { headers });
            return response;
        }
    },
    // edit beneficiary
    async editBeneficiary({}, { payload, id }) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Beneficiary/update/${id}`, encryptedData, { headers });
            return response;
        }
    },
};
const getters = {
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};